import { Component, OnInit, Input, Output } from '@angular/core';

import { FormControl } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';


import * as _moment from 'moment';
import { defaultFormat as _rollupMoment, Moment } from 'moment';

import { NgZone } from "@angular/core";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { CallsService } from 'src/app/services/calls/calls.service';

am4core.useTheme(am4themes_animated);



export const MY_FORMATS = {
    parse: {
        dateInput: 'MM/YYYY',
    },
    display: {
        dateInput: 'MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

const moment = _rollupMoment || _moment;

@Component({
    selector: 'app-calls',
    templateUrl: './calls.component.html',
    styleUrls: ['./calls.component.scss'],
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ]
})
export class CallsComponent implements OnInit {

    public atualPage = 'calls';

    public calls = [];
    public filteredCalls = [];
    public loading = true;
    public searchFilter = "";

    date = new FormControl(_moment());
    public labelDateSelected;
    public months = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
    ];

    // Filtros
    public call_type = "0";
    public phone_type = "0";
    public call_status = "todos";



    constructor(
        private zone: NgZone,
        private callsService : CallsService
    ) { }

    ngOnInit() {
        this.labelDateSelected = this.months[this.date.value.month()] + "/" + this.date.value.year();
        this.getCalls();
    }

    ngAfterViewInit() {
        
    }

    chosenYearHandler(normalizedYear: Moment) {
        const ctrlValue = this.date.value;
        ctrlValue.year(normalizedYear.year());
        this.date.setValue(ctrlValue);
    }

    chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
        const ctrlValue = this.date.value;
        ctrlValue.month(normalizedMonth.month());
        this.date.setValue(ctrlValue);
        this.labelDateSelected = this.months[normalizedMonth.month()] + "/" + normalizedMonth.year();
        this.getCalls();
        datepicker.close();
    }

    getCalls() {
        this.loading = true;
        let month = this.date.value.month()+1;
        let year = this.date.value.year();
        let call_type = JSON.parse(JSON.stringify(this.call_type));
        let phone_type = JSON.parse(JSON.stringify(this.phone_type));
        let call_status = JSON.parse(JSON.stringify(this.call_status));

        this.callsService.list(month, year, call_type, phone_type, call_status).subscribe((res) => {
            this.calls = res.calls;
            this.calls.forEach((item) => {
                item.duration = new Date(item.seconds * 1000).toISOString().substr(11, 8);
                item.duration_spoken = new Date(item.seconds_spoken * 1000).toISOString().substr(11, 8);
            })
            this._filter();
            this.loading = false;

        })
    }

    _filter() {
        let search = JSON.parse(JSON.stringify(this.searchFilter)).toUpperCase();
        if (search) {
            this.filteredCalls = this.calls.filter((item) => {
                for (var key in item) {
                    if (String(item[key]).toUpperCase().includes(search)) {
                        return true;
                    }
                }
            })
        } else {
            this.filteredCalls = JSON.parse(JSON.stringify(this.calls));
        }
    }

    getNow() {
        return new Date();
    }

}
